// Simple cart data for widget previews
export const getPreviewCartData = () => ({
  items: [
    {
      final_price: 10000, // $100.00 in cents
      id: 1,
      product_id: 456,
      quantity: 1,
      requires_shipping: true,
      variant_id: 123,
      vendor: 'Test Vendor',
    },
  ],
  items_subtotal_price: 10000,
  total_price: 10000,
});

// Expose to window for widget script access
if (typeof window !== 'undefined') {
  (window as any).previewCartData = getPreviewCartData();
}
